import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Style from './Styles/LoadingComponentStyle'

export default function LoadingComponent() {
  const classes = Style();

  return (
    <div style={classes.root}>
      <CircularProgress color="secondary" style={classes.circularProgress} />
    </div>
  );
}